module.exports = __webpack_public_path__ + "img/twittericon.d57054b6.svg";